import { DEFAULT_CONTENT_TYPE } from './schema.js';
export const COMMON_HEADERS = [
    { name: 'Access-Control-Allow-Headers', value: '*' },
    { name: 'Access-Control-Allow-Origin', value: '*', picker: 'cors-origin' },
    { name: 'Cache-Control', value: 'no-cache' },
    {
        name: 'Content-Disposition',
        value: 'attachment; filename="out.txt"',
        picker: 'content-disposition',
    },
    { name: 'Content-Security-Policy', value: "default-src 'self'", picker: 'csp' },
    { name: 'Content-Type', value: DEFAULT_CONTENT_TYPE },
    { name: 'Cross-Origin-Embedder-Policy', value: 'require-corp' },
    { name: 'Cross-Origin-Opener-Policy', value: 'same-origin' },
    { name: 'Cross-Origin-Resource-Policy', value: 'same-site' },
    { name: 'Referrer-Policy', value: 'no-referrer', picker: 'referrer-policy' },
    {
        name: 'Set-Cookie',
        value: 'session=abc123; Path=/; Secure; HttpOnly; SameSite=Lax',
        picker: 'set-cookie',
    },
    { name: 'X-Content-Type-Options', value: 'nosniff' },
    { name: 'X-Frame-Options', value: 'DENY', picker: 'xfo' },
];
